/* eslint-disable react-hooks/exhaustive-deps */
import { SildeStyleOne } from "../slideComponent/slideStyle";
import styles from "./category.module.scss";
import React, { Fragment, useCallback, useEffect, useMemo, useState } from "react";
import NewestPosts from "./../newestPosts/newestPosts";
import { IBaseBox } from "./../../model/base";
import PaginationCustom from "../pagination";
import classNames from "classnames";
import { useRouter } from "next/router";
import { findAdsByIds, mergeByProperty, parse_query_string } from "../../util/functionGlobal";
import { IAds } from "./../../model/ads";
import { ICategory } from "../../model/base";
import Link from "next/link";
import ItemPost from "../newestPosts/itemPost";

const Category = ({
  articleSlide,
  data,
  listAds,
  categories,
  idCate,
  cateName,
  categoryIds,
}: {
  data: IBaseBox[][];
  articleSlide: IBaseBox[];
  listAds: IAds[];
  categories: ICategory[];
  idCate: number;
  cateName?: string;
  categoryIds: number[];
}) => {
  const router = useRouter();
  const [categoryBreadcrumb, setCategoryBreadcrumb] = useState(null);

  const newestPost: IBaseBox[][] = data;
  const [breadcrumb, setBreadcrumb] = useState<ICategory[]>([]);
  const genCategory = (id: number, arr: ICategory[]) => {
    const cate = categories.find((cate) => cate.id === id);
    if (cate) {
      arr.push(cate);
      if (cate.parent_id) {
        genCategory(cate.parent_id, arr);
      }
    }
  };

  const [page, setPage] = useState<number>(1);

  const rendBreadcrumb = () => {
    let breadcrumbBase: ICategory[] = [];
    genCategory(idCate, breadcrumbBase);
    return breadcrumbBase;
  };

  useEffect(() => {
    setBreadcrumb(rendBreadcrumb());
    setCategoryBreadcrumb(true);
  }, [data]);

  const schemaBreadcrumb = useMemo(() => {
    if (!categoryBreadcrumb) return null;

    const breadcrumbItems =
      breadcrumb.length > 0
        ? [...breadcrumb].reverse().map((bc, index) => ({
            "@type": "ListItem",
            position: index + 3,
            name: bc.title,
            item: "https://www.sapo.vn/blog/" + bc.alias,
          }))
        : [];

    return {
      "@context": "http://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Trang chủ",
          item: "https://www.sapo.vn",
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "Blog",
          item: "https://www.sapo.vn/blog",
        },
        ...breadcrumbItems,
      ],
    };
  }, [categoryBreadcrumb, breadcrumb, cateName, router.asPath]);

  const [isHasMore, setIsHasMore] = useState<boolean>(true);
  const [loadingMore, setLoadingMore] = useState<boolean>(false);
  const [dataMore, setDataMore] = useState<IBaseBox[]>([]);
  const loadMoreArticle = useCallback(() => {
    setLoadingMore(true);
    fetch(`/blog/api/articles_index?limit=6&skip=${30 + (page - 1) * 6}&categoryIds=${categoryIds.join(",")}`)
      .then((response) => response?.json())
      .then((data: IBaseBox[]) => {
        const dataModCategory = data.map((item) => {
          return {
            ...item,
            categories: mergeByProperty(categories, item.category_article_mapping, "id", "category_id"),
          };
        });
        setDataMore((prev) => [...prev, ...dataModCategory]);
        setPage((prev) => prev + 1);
        setLoadingMore(false);
        if (data.length < 6) {
          setIsHasMore(false);
        }
      });
  }, [page, categories]);

  return (
    <>
      <>{categoryBreadcrumb && <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaBreadcrumb) }} />}</>
      <div id={styles.wrapper} className="main-content">
        <div className="container">
          {breadcrumb.length > 0 ? (
            <ul className={styles["breadcrumb"]}>
              <li>
                <Link href="/">Blog</Link>
                <span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    version="1.1"
                    id="Capa_1"
                    x="0px"
                    y="0px"
                    viewBox="0 0 490.8 490.8"
                    xmlSpace="preserve"
                  >
                    <path d="M135.685,3.128c-4.237-4.093-10.99-3.975-15.083,0.262c-3.992,4.134-3.992,10.687,0,14.82  l227.115,227.136L120.581,472.461c-4.237,4.093-4.354,10.845-0.262,15.083c4.093,4.237,10.845,4.354,15.083,0.262  c0.089-0.086,0.176-0.173,0.262-0.262l234.667-234.667c4.164-4.165,4.164-10.917,0-15.083L135.685,3.128z" />
                    <path d="M128.133,490.68c-5.891,0.011-10.675-4.757-10.686-10.648c-0.005-2.84,1.123-5.565,3.134-7.571l227.136-227.115  L120.581,18.232c-4.171-4.171-4.171-10.933,0-15.104c4.171-4.171,10.933-4.171,15.104,0l234.667,234.667  c4.164,4.165,4.164,10.917,0,15.083L135.685,487.544C133.685,489.551,130.967,490.68,128.133,490.68z" />
                  </svg>
                </span>
              </li>
              {breadcrumb.reverse().map((bc, index) => (
                <li key={index}>
                  <Link href={"/" + bc.alias} legacyBehavior>
                    {bc.id === idCate ? (
                      <a>
                        <h1>{bc.title}</h1>
                      </a>
                    ) : (
                      <a>{bc.title}</a>
                    )}
                  </Link>
                  {index + 1 < breadcrumb.length ? (
                    <span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        xmlnsXlink="http://www.w3.org/1999/xlink"
                        version="1.1"
                        id="Capa_1"
                        x="0px"
                        y="0px"
                        viewBox="0 0 490.8 490.8"
                        xmlSpace="preserve"
                      >
                        <path d="M135.685,3.128c-4.237-4.093-10.99-3.975-15.083,0.262c-3.992,4.134-3.992,10.687,0,14.82  l227.115,227.136L120.581,472.461c-4.237,4.093-4.354,10.845-0.262,15.083c4.093,4.237,10.845,4.354,15.083,0.262  c0.089-0.086,0.176-0.173,0.262-0.262l234.667-234.667c4.164-4.165,4.164-10.917,0-15.083L135.685,3.128z" />
                        <path d="M128.133,490.68c-5.891,0.011-10.675-4.757-10.686-10.648c-0.005-2.84,1.123-5.565,3.134-7.571l227.136-227.115  L120.581,18.232c-4.171-4.171-4.171-10.933,0-15.104c4.171-4.171,10.933-4.171,15.104,0l234.667,234.667  c4.164,4.165,4.164,10.917,0,15.083L135.685,487.544C133.685,489.551,130.967,490.68,128.133,490.68z" />
                      </svg>
                    </span>
                  ) : (
                    ""
                  )}
                </li>
              ))}
            </ul>
          ) : (
            <h1>{cateName}</h1>
          )}
          <div className="row">
            {articleSlide?.length > 0 && (
              <>
                <div className={classNames(styles["no-padding-es"], "col-12 col-lg-8")}>
                  <SildeStyleOne slides={articleSlide} />
                </div>
                <div
                  className="col-lg-4 topic-banner d-none d-lg-block"
                  dangerouslySetInnerHTML={{ __html: listAds.find((item) => item.id === 135)?.content }}
                />
              </>
            )}
            <div className={classNames(styles["newest-posts"], "col-12")}>
              <div className="row">
                {newestPost?.map((posts, index) => (
                  <Fragment key={index}>
                    <NewestPosts posts={posts} />
                  </Fragment>
                ))}
                {dataMore.map((post) => (
                  <ItemPost key={post.article_id} post={post} firstIndex={false} />
                ))}
              </div>
            </div>
            {/* {count > 15 && <PaginationCustom page={page} setPage={setPage} itemPerPage={itemPerPage} totalItem={count} />}
             */}
          </div>
          {isHasMore && newestPost.flat().length >= 15 && (
            <div className="d-flex align-items-center justify-content-center">
              <button className={classNames(styles["btn-loadmore"])} onClick={loadMoreArticle} disabled={loadingMore}>
                Xem thêm
                {loadingMore ? (
                  <span>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                      <path d="M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48 368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49 48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z"></path>
                    </svg>
                  </span>
                ) : null}
              </button>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Category;
